import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M24.535,13.47,16,12.382V5a3,3,0,0,0-6,0V20s-3.72-1.73-4-1.829A3,3,0,0,0,3.2,23.4l8,6A2.983,2.983,0,0,0,13,30h11.7a2,2,0,0,0,1.985-1.752l1.29-10.318A4,4,0,0,0,24.535,13.47Z"/><path d="M29,10a1,1,0,0,1-.858-.483A9.971,9.971,0,0,0,20,5H19a1,1,0,0,1,0-2h1a12.009,12.009,0,0,1,9.857,5.485A1,1,0,0,1,29,10Z"/>';
export var FingerDrawSVG = function FingerDrawSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FingerDrawSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FingerDrawSVG);